require('./brochure-popup.scss');
import {multiStepForm} from "../utils";

$(() => {
    multiStepForm('#multiStepFormBrochureModal');
});